import JSONAPIAdapter from '@ember-data/adapter/json-api';

// eslint-disable-next-line ember/no-classic-classes
export default JSONAPIAdapter.extend({
  modelName: 'subscription-order-line-item'
});